import { http } from '@/providers/apis/http';
import { isEmptyValue } from '@/utils/utils';

export class SsoSetupApi {

    private static INSTANCE = new SsoSetupApi();

    private namespace = 'api/admin/v1/tenant';

    static get instance() {
        return this.INSTANCE;
    }

    public getConfigBasedOnSso(ssoType: string) {
        const endpoint = `${this.namespace}/sso/${ssoType}/settings`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return (response.data);
        });
    }

}

export const ssoSetupApi = SsoSetupApi.instance;
